<template>
  <div class="lg:tw-flex">
    <div class="lg:tw-w-1/2 tw-px-12 tw-py-12">
      <h3 class="tw-pl-8 tw-text-3xl tw-uppercase tw-mb-4">Order Type</h3>

      <div class="tw-flex tw-mb-8">
        <button 
          :class="['tw-w-1/2 tw-font-5xl tw-font-black tw-rounded-l-full tw-uppercase tw-px-4 tw-py-4 tw-border', {'tw-bg-orange-medium tw-border-orange-medium tw-text-white': state.orderType == 'pickup', 'tw-border-black': state.orderType != 'pickup'}]"
          @click="setOrderType('pickup')">
          Pick-Up
        </button>
        <button 
          :class="['tw-w-1/2 tw-font-5xl tw-font-black tw-rounded-r-full tw-uppercase tw-px-4 tw-py-4 tw-border', {'tw-bg-orange-medium tw-border-orange-medium  tw-text-white': state.orderType == 'delivery', 'tw-border-black': state.orderType != 'delivery'}]"
          @click="setOrderType('delivery')">Delivery</button>
      </div>

      <div class="tw-pl-8 tw-mb-16 tw-italic" v-if="state.orderType == 'delivery'">
        Deliveries will be completed by a third-party delivery service and setup is not included.
        For catering setup, please place your order through one of our catering representatives at
        <a href="tel:18556974232" class="tw-text-orange-medium">855.MYPIADA</a>
      </div>

      <div class="tw-mt-16 tw-mb-16">
        <h3 class="tw-pl-8 tw-text-3xl tw-uppercase tw-mb-4">{{ state.orderType == 'pickup' ? 'Pick-up' : 'Delivery' }} Location</h3>
        <AutoComplete
          class="tw-block tw-py-6 tw-px-8 tw-mb-4 tw-text-2xl tw-w-full tw-appearance-none tw-border-gray-400 tw-border-2 tw-rounded-full focus:tw-outline-none tw-bg-transparent"
          placeholder="Enter Zip Code, City or State"
          v-model="searchText"
          :options="{fields: ['address_components', 'geometry', 'name']}"
          @place_changed="setPlace"></AutoComplete>

        <button 
          v-if="!state.userCoordinates && !state.userOptedOutGeo"
          class="tw-pl-8 tw-text-gray-500 hover:tw-text-orange-medium"
          @click="userGeoLocation">
          Use My Location 
          <span 
            v-if="!state.settingUserCoordinates"
            class="fa fa-location-arrow tw-text-lg"
            ></span>
          <span 
            v-if="state.settingUserCoordinates" 
            class="fa fa-spinner tw-animate-spin"></span>
        </button>
      </div>

      <div class="md:tw-max-h-128 md:tw-overflow-y-auto">
        <ListLocation
          v-if="props.selectedLocation"
          :location="props.selectedLocation"
          :selected="true"
          @select-location="attemptSetLocation" />

        <ListLocation
          v-for="l in filtered_locations"
          :location="l"
          :selected="props.selectedLocation != null && props.selectedLocation.id == l.id"
          @select-location="attemptSetLocation"
          v-bind:key="l.extref" />

        <template v-if="filtered_locations.length == 0">
          <div class="tw-mb-3 tw-border-2 tw-px-8 tw-py-8 tw-rounded-3xl tw-border-gray-30">
            <h4 class="tw-text-2xl tw-font-bold tw-mb-0 tw-text-center">No Piada locations are close to you. Try searching for a different location.</h4>
          </div>
        </template>
      </div>
    </div>

    <div class="tw-bg-gray-300 lg:tw-w-1/2 lg:tw-border-l tw-border-gray-500 tw-flex tw-items-center tw-justify-center">
      <GMapMap
        :center="state.mapCenter"
        map-type-id="terrain"
        :zoom="state.mapZoom"
        :options="state.mapOptions"
        style="height: 100%;width:100%;flex:1;"
      >
        <GMapMarker
          :key="'gmap_marker_' + location.id"
          v-for="location in state.locations"
          :clickable="true"
          @click="openInfoWindow(location.id)"
          :icon= '{
              url: "/map-pin-tear.png",
              scaledSize: {width: 65, height: 65},
              labelOrigin: {x: 0, y: 0}
          }'
          :position="{lat: location.latitude, lng: location.longitude}"
        >
          <GMapInfoWindow
            :opened="state.openedInfoWindow == location.id">
            <LocationInfoWindow
              :location="location"
              @select-location="attemptSetLocation"
              v-bind:key="location.extref" />
          </GMapInfoWindow>
        </GMapMarker>
      </GMapMap>
    </div>

    <TwModal
      v-show="state.confirmModalOpen"
      :hasAccept="true"
      :hasHeader="false"
      @emitClose="closeLocationModal"
      >
      <template v-slot:body>
        <div class="tw-relative tw-pr-24 tw-w-full">
          <h2 class="tw-mx-8 tw-font-black tw-text-5xl tw-mb-6 lg:tw-my-8">Change Location?</h2>
           <button
              type="button"
              class="tw-text-5xl tw-absolute tw-right-2 tw-top-0 hover:tw-text-orange-medium tw-transition-all tw-duration-300"
              @click="closeLocationModal"
            >
              &times;
            </button>
        </div>

        <p class="tw-mx-8 tw-mb-8 tw-text-3xl !tw-leading-relaxed">
         It looks like you have already started an order at <span class="tw-font-bold" v-if="basketLocation">{{basketLocation!.name}}</span> <span v-else>another location</span>. Your basket will be cleared if you select a new location. Do you wish to continue?
        </p>
      </template>

      <template v-slot:footer>
        <div class="tw-flex tw-justify-center tw-items-center tw-px-8 tw-pt-16 tw-pb-8">
          <TwButton 
            cssClass="tw-border-2 tw-border-gray-400 tw-text-gray-400 hover:tw-bg-orange-medium hover:tw-border-orange-medium hover:tw-text-white tw-uppercase tw-font-bold tw-px-16 tw-py-3 tw-transition-all tw-duration-200 tw-mr-8 tw-rounded-full"
            @emit-click="closeLocationModal" 
            :isLoading="false"
            :isDisabled="false" 
            :buttonText="'Cancel'"/>

          <TwButton 
            cssClass="tw-bg-orange-medium tw-border-2 tw-border-orange-medium tw-text-white hover:tw-bg-black hover:tw-border-black tw-uppercase tw-font-bold tw-px-16 tw-py-3 tw-transition-all tw-duration-200 tw-ml-8 tw-rounded-full tw-inline-block"
            @emit-click="confirmLocationChange" 
            :isLoading="false"
            :isDisabled="false" 
            :buttonText="'Start New Order'"/>
        </div>
      </template>
    </TwModal>
  </div>
</template>

<script setup lang="ts">
  import {
    reactive, onMounted, computed, watch, ref, nextTick,
  } from 'vue';
  import type {PropType} from 'vue';
  import { getDistance } from 'geolib';

  // Data
  import type Location from '../../classes/Location';
  import type LatLong from '../../types/LatLong';
  import { useLocationsStore } from '../../stores/locations';
  import { useUserStore } from "../../stores/user";
  import { useBasketStore } from "../../stores/basket";

  // Partials
  import AutoComplete from '../../overrides/autocomplete.vue';
  import ListLocation from './_ListLocation.vue';
  import LocationInfoWindow from './_LocationInfoWindow.vue';
  import TwModal from '../../components/TwModal.vue';
  import TwButton from '../../components/TwButton.vue';


const props = defineProps({
    selectedLocation: {
      type: (Object as PropType<Location>),
      default: null,
    },
  });

  const emit = defineEmits(['selectLocation', 'orderTypeSet']);

  const userStore = useUserStore();
  const basketStore = useBasketStore();
  const locationsStore = useLocationsStore();

  const searchText = ref('initial search');

  const state = reactive({
      locations: ([] as Location[]),
      orderType: "pickup",
      settingUserCoordinates: false,
      userOptedOutGeo: false,
      userCoordinates: null as (LatLong | null),
      mapCenter: {lat: 40.1709571, lng: -83.05},
      filterDistance: false,
      confirmModalOpen: false,
      confirmModalLocation: undefined as (undefined | Location),
      mapZoom: 7,
      openedInfoWindow: 0,
      mapOptions: {
        panControl: false,
        zoomControl: true,
        scaleControl: false,
        streetViewControl: false,
        mapTypeControl: false,
        scrollwheel: false,
        styles: [
          {
            "featureType": "administrative.locality",
            "elementType": "all",
            "stylers": [
              {
                "hue": "#2c2e33"
              },
              {
                "saturation": 7
              },
              {
                "lightness": 19
              },
              {
                "visibility": "on"
              }
            ]
          },
          {
            "featureType": "administrative.locality",
            "elementType": "labels.text",
            "stylers": [
              {
                "visibility": "on"
              },
              {
                "saturation": "-3"
              }
            ]
          },
          {
            "featureType": "administrative.locality",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#f39247"
              }
            ]
          },
          {
            "featureType": "landscape",
            "elementType": "all",
            "stylers": [
              {
                "hue": "#ff0000"
              },
              {
                "saturation": -100
              },
              {
                "lightness": 100
              },
              {
                "visibility": "on"
              }
            ]
          },
          {
            "featureType": "poi",
            "elementType": "all",
            "stylers": [
              {
                "hue": "#ffffff"
              },
              {
                "saturation": -100
              },
              {
                "lightness": 100
              },
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "poi.school",
            "elementType": "geometry",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "poi.school",
            "elementType": "geometry.fill",
            "stylers": [
              {
                "color": "#f39247"
              },
              {
                "saturation": "0"
              },
              {
                "visibility": "on"
              }
            ]
          },
          {
            "featureType": "road",
            "elementType": "geometry",
            "stylers": [
              {
                "hue": "#ff6f00"
              },
              {
                "saturation": "100"
              },
              {
                "lightness": 31
              },
              {
                "visibility": "simplified"
              }
            ]
          },
          {
            "featureType": "road",
            "elementType": "geometry.stroke",
            "stylers": [
              {
                "color": "#f39247"
              },
              {
                "saturation": "0"
              }
            ]
          },
          {
            "featureType": "road",
            "elementType": "labels",
            "stylers": [
              {
                "hue": "#008eff"
              },
              {
                "saturation": -93
              },
              {
                "lightness": 31
              },
              {
                "visibility": "on"
              }
            ]
          },
          {
            "featureType": "road.highway.controlled_access",
            "elementType": "geometry.fill",
            "stylers": [
              {
                "visibility": "on"
              }
            ]
          },
          {
            "featureType": "road.arterial",
            "elementType": "geometry.fill",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "road.arterial",
            "elementType": "geometry.stroke",
            "stylers": [
              {
                "visibility": "on"
              },
              {
                "color": "#f3dbc8"
              },
              {
                "saturation": "0"
              }
            ]
          },
          {
            "featureType": "road.arterial",
            "elementType": "labels",
            "stylers": [
              {
                "hue": "#bbc0c4"
              },
              {
                "saturation": -93
              },
              {
                "lightness": -2
              },
              {
                "visibility": "simplified"
              }
            ]
          },
          {
            "featureType": "road.arterial",
            "elementType": "labels.text",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "road.arterial",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "visibility": "on"
              },
              {
                "color": "#959595"
              }
            ]
          },
          {
            "featureType": "road.local",
            "elementType": "geometry",
            "stylers": [
              {
                "hue": "#e9ebed"
              },
              {
                "saturation": -90
              },
              {
                "lightness": -8
              },
              {
                "visibility": "simplified"
              }
            ]
          },
          {
            "featureType": "road.local",
            "elementType": "labels.text",
            "stylers": [
              {
                "visibility": "on"
              },
              {
                "color": "#848484"
              }
            ]
          },
          {
            "featureType": "road.local",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#818080"
              },
              {
                "visibility": "on"
              }
            ]
          },
          {
            "featureType": "road.local",
            "elementType": "labels.text.stroke",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "transit",
            "elementType": "all",
            "stylers": [
              {
                "hue": "#e9ebed"
              },
              {
                "saturation": 10
              },
              {
                "lightness": 69
              },
              {
                "visibility": "on"
              }
            ]
          },
          {
            "featureType": "transit.line",
            "elementType": "geometry.fill",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "transit.station",
            "elementType": "geometry",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "transit.station",
            "elementType": "labels",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "transit.station.bus",
            "elementType": "geometry",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "transit.station.bus",
            "elementType": "labels.text",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "water",
            "elementType": "all",
            "stylers": [
              {
                "hue": "#e9ebed"
              },
              {
                "saturation": -78
              },
              {
                "lightness": 67
              },
              {
                "visibility": "simplified"
              }
            ]
          }
        ]
      },
   })

  const getLocations = () => {
   state.locations = locationsStore.locations;
  }

  const filtered_locations = computed(() => {
    if (state.filterDistance) {
      const filtered = state.locations.filter((loc: Location) => {
        if (props.selectedLocation && props.selectedLocation.extref == loc.extref) {
          return false
        } else if (typeof(loc.distanceFrom!) != undefined) {
          return loc.distanceFrom! < 25
        } else {
          return true
        }
      })

      if (filtered && filtered.length > 0) {
        const sorted = filtered.sort((a, b) => Number(a.distanceFrom) - Number(b.distanceFrom));

        return sorted.slice(0, 5);
      } else {
        return [];
      }
    } else {
      return state.locations.filter((loc: Location) => {
        if (props.selectedLocation && props.selectedLocation.extref == loc.extref) {
          return false
        } else {
          return true;
        }
      })
    }
  })

  const confirmLocationChange = () => {
    basketStore.clearBasket().then(() => {
      if (location != null) {
        setLocation(state.confirmModalLocation!);
        closeLocationModal();
      }
    })
  }

  const closeLocationModal = () => {
    state.confirmModalOpen = false;
    window.setTimeout(function() {
      state.confirmModalLocation = undefined;
    }, 500);
  }

  const basketLocation = computed(() => {
    if (basketStore.basket && basketStore.basket.vendorid && state.locations) {
      let matchedLocation = state.locations.filter((loc: Location) => {
        return loc.id == basketStore.basket!.vendorid
      })

      return matchedLocation[0];
    } else {
      return undefined;
    }
  })

  const attemptSetLocation = (location: Location) => {
    if (basketStore.basket && location.id != basketStore.basket.vendorid) {
      state.confirmModalOpen = true;
      state.confirmModalLocation = location;
    } else {
      setLocation(location)
    }
  }

  const setLocation = (location: Location) => {
    if (location != null) {
      userStore.setUserLocation(location);
      emit('selectLocation', location);
    }
  }

  function setOrderType(newOrderType: string) {
    state.orderType = newOrderType;
    emit('orderTypeSet', newOrderType);
  }

  const userGeoLocation = () => {
    state.settingUserCoordinates = true;
    navigator.geolocation.getCurrentPosition(
      (position: any) => {
        if (typeof(position.coords != undefined)) {
          const geoLat = position.coords.latitude;
          const geoLong = position.coords.longitude;
          state.userCoordinates = {lat: geoLat, long: geoLong} as LatLong;
          
          setFromLatLong(geoLat, geoLong);
        }
        state.settingUserCoordinates = false;
      },
      (error: any) => {
        state.settingUserCoordinates = false;
      });
  }

  const setFromLatLong = (lat: number, long: number) => {
    state.mapCenter = {lat: lat, lng: long};
    state.mapZoom = 10;

    setLocationDistancesFromSelection(lat.toString(), long.toString());
  }

  const setPlace = ((p: any) => {
    const pLat = p.geometry.location.lat();
    const pLong  = p.geometry.location.lng();
    state.mapCenter = {lat: pLat, lng: pLong};
    state.filterDistance = true;
    state.mapZoom = 10;

    setLocationDistancesFromSelection(pLat, pLong);
  })

  const setLocationDistancesFromSelection = (lat?: string, long?: string) => {
    let currentLocations = state.locations;

    if (lat && long) {
      currentLocations.forEach((loc: Location) => {
        let distance = getDistance({latitude: lat, longitude: long},{latitude: loc.latitude, longitude:loc.longitude}, 1);

        loc.distanceFrom = parseFloat((distance/1609.344).toFixed(1));
      })

      state.locations = currentLocations;
      state.filterDistance = true; // Since the locations now have a distance set, we can filter
    } else {
      currentLocations.forEach((loc: Location) => {
        loc.distanceFrom = undefined;
      })

      state.locations = currentLocations;
      state.filterDistance = false; // Since the locations now have a distance set, we can filter
    }
  }

  const openInfoWindow = (id: number) => {
    state.openedInfoWindow = id;
  }

  watch(searchText, (str: string) => { 
    if (!str || str.length == 0) {
      // Clear location search
      if (state.userCoordinates) {
        // Switch back to user location
        setFromLatLong(parseFloat(state.userCoordinates.lat), parseFloat(state.userCoordinates.long));
      } else {
        // clear set lat/long
        setLocationDistancesFromSelection(undefined, undefined)
      }
    }
  })

  onMounted(() => {
    getLocations();
    // Try to prefetch user location

    nextTick(() => {
      // Give data time to populate after the next tick
      navigator.geolocation.getCurrentPosition(
        (position: any) => {
          if (typeof(position.coords != undefined)) {
            const geoLat = position.coords.latitude;
            const geoLong = position.coords.longitude;
            state.userCoordinates = {lat: geoLat, long: geoLong} as LatLong;
            
            setFromLatLong(geoLat, geoLong);
          } else {
            state.userOptedOutGeo = true;
          }
          state.settingUserCoordinates = false;
        },
        (error: any) => {
          state.userOptedOutGeo = true;
          state.settingUserCoordinates = false;
        });
    })

    
  })

</script>

<style>
  .vue-map-container {
    flex: 1;
  }
</style>